import { BackspaceReverseIcon } from './BackspaceReverseIcon';

/**
 * author: Michael Irigoyen
 * id 49AA61F3-2E3D-4EEA-BFB1-32D59C6906F0
 * name backspace-reverse
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/backspace-reverse.svg
 * tags
 */
export const EraseReverseIcon = BackspaceReverseIcon;
export default EraseReverseIcon